import { RESOLVE_SEARCH_SUCCESS } from "core-web/state/models/Page/constants";
import store from "core-web/state/store";

export const resolveSearch = (search) => (dispatch) => {
    try {
        dispatch({
            type: RESOLVE_SEARCH_SUCCESS,
            pageSearch: search,
        });
    } catch (e) {
        console.error(e);
    }
};

export default (search) => store.dispatch(resolveSearch(search));
